<input type="text" id="scriptHelper" class="sr-only">
<div class="main-content" *ngIf="!profile">
  <div class="loader"></div>
</div>
<div class="app-loading" *ngIf="loading">
  <div class="logo"></div>
  <svg class="spinner" viewBox="25 25 50 50">
    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
  </svg>
  <p class="app-loading-message">{{loadingMessage}}</p>
</div>

<main class="container-setup" *ngIf="profile">

  <header class="header-setup">
    <h4>Setup</h4>
    <p>Instale o Polen na sua plataforma seguindo os passos abaixo.</p>
  </header>

  <section class="left-side-setup">

    <div class="container-setup-script" *ngIf="profile.platformInfo != null">

      <h4>Script do Polen</h4>

      <div class="card" *ngIf="profile.platformInfo.seoName == 'vtex-flower'">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Adicione o script abaixo no seu site para começar a polinizar</label>
                <textarea id="scriptArea" name="script"
                          style="width: 100%;height: 240px; padding: 9.5px; margin: 0 0 10px; font-size: 13px; line-height: 1.42857143; color: #333; word-break: break-all; word-wrap: break-word; background-color: #f5f5f5; border: 1px solid #ccc; border-radius: 4px;"
                          readonly>{{script}}</textarea>
              </div>
            </div>
          </div>
          <div>
            <button type="button" class="btn btn-info btn-fill" (click)="copyToClipboard()">Copiar</button>
            &nbsp;ou&nbsp;
            <button class="btn btn-warning btn-fill btn-wd" (click)="sendToDeveloper()">Enviar para
              meu
              desenvolvedor!</button>
          </div>
        </div>
      </div >
      <div class="card" *ngIf="profile.platformInfo.seoName == 'woocommerce-flower'">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Adicione o script abaixo no seu site para começar a polinizar</label>
                <textarea id="scriptArea" name="script"
                          style="width: 100%;height: 240px; padding: 9.5px; margin: 0 0 10px; font-size: 13px; line-height: 1.42857143; color: #333; word-break: break-all; word-wrap: break-word; background-color: #f5f5f5; border: 1px solid #ccc; border-radius: 4px;"
                          readonly>{{script}}</textarea>
              </div>
            </div>
          </div>
          <div>
            <button type="button" class="btn btn-info btn-fill" (click)="copyToClipboard()">Copiar</button>
            &nbsp;ou&nbsp;
            <button class="btn btn-warning btn-fill btn-wd" (click)="sendToDeveloper()">Enviar para
              meu
              desenvolvedor!</button>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="profile.platformInfo.seoName == 'loja-integrada-flower'">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Adicione o script abaixo no seu site para começar a polinizar</label>
                <textarea id="scriptArea" name="script"
                          style="width: 100%;height: 240px; padding: 9.5px; margin: 0 0 10px; font-size: 13px; line-height: 1.42857143; color: #333; word-break: break-all; word-wrap: break-word; background-color: #f5f5f5; border: 1px solid #ccc; border-radius: 4px;"
                          readonly>{{script}}</textarea>
              </div>
            </div>
          </div>
          <div>
            <button type="button" class="btn btn-info btn-fill" (click)="copyToClipboard()">Copiar</button>
            &nbsp;ou&nbsp;
            <button class="btn btn-warning btn-fill btn-wd" (click)="sendToDeveloper()">Enviar para
              meu
              desenvolvedor!</button>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'tray-pollinator' && isAdmin">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Adicione o script abaixo no seu site para começar a polinizar</label>
                <textarea id="scriptArea" name="script"
                          style="width: 100%;height: 240px; padding: 9.5px; margin: 0 0 10px; font-size: 13px; line-height: 1.42857143; color: #333; word-break: break-all; word-wrap: break-word; background-color: #f5f5f5; border: 1px solid #ccc; border-radius: 4px;"
                          readonly>{{script}}</textarea>
              </div>
            </div>
          </div>
          <div>
            <button type="button" class="btn btn-info btn-fill" (click)="copyToClipboard()">Copiar</button>
            &nbsp;ou&nbsp;
            <button class="btn btn-warning btn-fill btn-wd" (click)="sendToDeveloper()">Enviar para
              meu
              desenvolvedor!</button>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'traycorp'">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Adicione o script abaixo no seu site para começar a polinizar</label>
                <textarea id="scriptArea" name="script"
                          style="width: 100%;height: 240px; padding: 9.5px; margin: 0 0 10px; font-size: 13px; line-height: 1.42857143; color: #333; word-break: break-all; word-wrap: break-word; background-color: #f5f5f5; border: 1px solid #ccc; border-radius: 4px;"
                          readonly>{{script}}</textarea>
              </div>
            </div>
          </div>
          <div>
            <button type="button" class="btn btn-info btn-fill" (click)="copyToClipboard()">Copiar</button>
            &nbsp;ou&nbsp;
            <button class="btn btn-warning btn-fill btn-wd" (click)="sendToDeveloper()">Enviar para
              meu
              desenvolvedor!</button>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'nuvemshop-flower' && isAdmin">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Adicione o script abaixo no seu site para começar a polinizar</label>
                <textarea id="scriptArea" name="script"
                          style="width: 100%;height: 240px; padding: 9.5px; margin: 0 0 10px; font-size: 13px; line-height: 1.42857143; color: #333; word-break: break-all; word-wrap: break-word; background-color: #f5f5f5; border: 1px solid #ccc; border-radius: 4px;"
                          readonly>{{script}}</textarea>
              </div>
            </div>
          </div>
          <div>
            <button type="button" class="btn btn-info btn-fill" (click)="copyToClipboard()">Copiar</button>
            &nbsp;ou&nbsp;
            <button class="btn btn-warning btn-fill btn-wd" (click)="sendToDeveloper()">Enviar para
              meu
              desenvolvedor!</button>
          </div>
        </div>
      </div>
      <div class="card"  *ngIf="isAdmin && profile.platformInfo != null && profile.platformInfo.seoName == 'xtech-flower'">
        <div class="card-header">
          <h4 class="card-title">Script Polen (só aparece para Admin)</h4>
        </div>
        <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Adicione o script abaixo no seu site para começar a polinizar</label>
                <textarea id="scriptArea" name="script"
                          style="width: 100%;height: 240px; padding: 9.5px; margin: 0 0 10px; font-size: 13px; line-height: 1.42857143; color: #333; word-break: break-all; word-wrap: break-word; background-color: #f5f5f5; border: 1px solid #ccc; border-radius: 4px;"
                          readonly>{{script}}</textarea>
              </div>
            </div>
          </div>
          <div>
            <button type="button" class="btn btn-info btn-fill" (click)="copyToClipboard()">Copiar</button>
            &nbsp;ou&nbsp;
            <button class="btn btn-warning btn-fill btn-wd" (click)="sendToDeveloper()">Enviar para
              meu
              desenvolvedor!</button>
          </div>
        </div>
      </div >
      <div class="card" *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'irroba'">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Adicione o script abaixo no seu site para começar a polinizar</label>
                <textarea id="scriptArea" name="script"
                          style="width: 100%;height: 240px; padding: 9.5px; margin: 0 0 10px; font-size: 13px; line-height: 1.42857143; color: #333; word-break: break-all; word-wrap: break-word; background-color: #f5f5f5; border: 1px solid #ccc; border-radius: 4px;"
                          readonly>{{script}}</textarea>
              </div>
            </div>
          </div>
          <div>
            <button type="button" class="btn btn-info btn-fill" (click)="copyToClipboard()">Copiar</button>
            &nbsp;ou&nbsp;
            <button class="btn btn-warning btn-fill btn-wd" (click)="sendToDeveloper()">Enviar para
              meu
              desenvolvedor!</button>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'cartx'">
        <div class="card-content">
          <div class="row" >
            <div class="col-md-12">
              <div class="form-group">
                <label>Adicione o script abaixo no seu site para começar a polinizar</label>
                <textarea id="scriptArea" name="script"
                          style="width: 100%;height: 240px; padding: 9.5px; margin: 0 0 10px; font-size: 13px; line-height: 1.42857143; color: #333; word-break: break-all; word-wrap: break-word; background-color: #f5f5f5; border: 1px solid #ccc; border-radius: 4px;"
                          readonly>{{script}}</textarea>
              </div>
            </div >
          </div>
          <div>
            <button type="button" class="btn btn-info btn-fill" (click)="copyToClipboard()">Copiar</button>
            &nbsp;ou&nbsp;
            <button class="btn btn-warning btn-fill btn-wd" (click)="sendToDeveloper()">Enviar para
              meu
              desenvolvedor!</button>
          </div>
        </div>
      </div>

      <div class="card" *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'vnda'">
        <div class="card-content">
          <div class="row" >
            <div class="col-md-12">
              <div class="form-group">
                <label>Adicione o script abaixo no seu site para começar a polinizar</label>
                <textarea id="scriptArea" name="script"
                          style="width: 100%;height: 240px; padding: 9.5px; margin: 0 0 10px; font-size: 13px; line-height: 1.42857143; color: #333; word-break: break-all; word-wrap: break-word; background-color: #f5f5f5; border: 1px solid #ccc; border-radius: 4px;"
                          readonly>{{script}}</textarea>
              </div>
            </div >
          </div>
          <div>
            <button type="button" class="btn btn-info btn-fill" (click)="copyToClipboard()">Copiar</button>
            &nbsp;ou&nbsp;
            <button class="btn btn-warning btn-fill btn-wd" (click)="sendToDeveloper()">Enviar para
              meu
              desenvolvedor!</button>
          </div>
        </div>
      </div>

      <div class="card" *ngIf="isGeneric">
        <div class="card-header">
          <h4 class="card-title">Script Polen</h4>
        </div>
        <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Adicione o script abaixo no seu site para começar a polinizar</label>
                <textarea id="scriptArea" name="script"
                          style="width: 100%;height: 240px; padding: 9.5px; margin: 0 0 10px; font-size: 13px; line-height: 1.42857143; color: #333; word-break: break-all; word-wrap: break-word; background-color: #f5f5f5; border: 1px solid #ccc; border-radius: 4px;"
                          readonly>{{script}}</textarea>
              </div>
            </div>
          </div>
          <div>
            <button type="button" class="btn btn-info btn-fill" (click)="copyToClipboard()">Copiar</button>
            &nbsp;ou&nbsp;
            <button class="btn btn-warning btn-fill btn-wd" (click)="sendToDeveloper()">Enviar para
              meu
              desenvolvedor!</button>
          </div>
        </div>
      </div>
    </div>


    <div class="container-setup-install" *ngIf="profile.platformInfo != null">

      <header>
        <h4>Adicionando o Polen na sua loja</h4>
      </header>

      <div id="vtex" *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'vtex-flower'">
        <div class="card">
          <div class="card-content">
            <p>São apenas dois passos para adicionar o script do Polen. </p>
            <ul style="margin-left: 25px;">
              <li>Adicionar o script no Google Tag Manager</li>
              <li>Adicionar a chave de acesso para sua API</li>
            </ul>
            <p>Para facilitar, fizemos um vídeo rápido explicativo:</p>
            <br>
            <h4>Adicionando o Polen no seu Google Tag Manager</h4>
            <div class="videoWrapper">
              <iframe src="https://www.youtube.com/embed/WuVS3-bJowA" allowfullscreen></iframe>
            </div>
            <h4>Associando o GTM no admin da VTex</h4>
            <p>Caso você já utilize o GTM, pode pular esse passo.</p>
            <div class="videoWrapper">
              <iframe src="https://www.youtube.com/embed/q7E16BdJPro" allowfullscreen></iframe>
            </div>
            <h4>Adicionar a chave de acesso para sua API</h4>
            <div class="videoWrapper">
              <iframe src="https://www.youtube.com/embed/pIRsIDL9jV0" allowfullscreen></iframe>
            </div>
            <br>
            <p>Pronto! Sua loja está integrada e pronta pra polinizar</p>
            <br>
            <p>Ficou alguma dúvida ou está com dificuldades na integração?
              <b>Nos chame no chat</b>
            </p>
          </div>
        </div>
      </div>

      <div id="woocommerce" *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'woocommerce-flower'">
        <div class="card">
          <div class="card-content">
            <p>São apenas dois passos para adicionar o script do Polen. </p>
            <ul style="margin-left: 25px;">
              <li>Adicionar o script no Google Tag Manager</li>
              <li>Adicionar a chave de acesso para sua API</li>
            </ul>
            <p>Para facilitar, acompanhe o passo a passo nos vídeos explicativos:</p>
            <br>
            <h4>Adicionando o Polen no seu Google Tag Manager</h4>
            <div class="videoWrapper">
              <iframe src="https://www.youtube.com/embed/WuVS3-bJowA" allowfullscreen></iframe>
            </div>
            <h4>Associando o GTM no admin do Wordpress</h4>
            <p>Caso você já utilize o GTM, pode pular esse passo.</p>
            <div class="videoWrapper">
              <iframe src="https://www.youtube.com/embed/-Kc-RKtqHSU" allowfullscreen></iframe>
            </div>
            <h4>Adicionar a chave de acesso para sua API</h4>
            <div class="videoWrapper">
              <iframe src="https://www.youtube.com/embed/2fucf6lA2N4?hl=pt&cc_lang_pref=pt&cc_load_policy=1" allowfullscreen></iframe>
            </div>
            <br>
            <p>Pronto! Sua loja está integrada e pronta pra polinizar</p>
            <br>
            <p>Ficou alguma dúvida ou está com dificuldades na integração?
              <b>Nos chame no chat</b>
            </p>
          </div>
        </div>
      </div>

      <div id="loja-integrada" *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'loja-integrada-flower'">
        <div class="card">
          <div class="card-content">
            <p>São apenas dois passos para adicionar o script do Polen. </p>
            <ul style="margin-left: 25px;">
              <li>Adicionar o script pelo Google Tag Manager ou diretamente no seu código</li>
              <li>Adicionar a chave de acesso para sua API</li>
            </ul>
            <p>Para facilitar, fizemos um vídeo rápido explicativo:</p>
            <h4>Adicionando o Polen no seu Google Tag Manager</h4>
            <div class="videoWrapper">
              <iframe src="https://www.youtube.com/embed/WuVS3-bJowA" allowfullscreen></iframe>
            </div>
            <p>
              Caso não tenha GTM pode ser adicionado diretamente no seu código, veja como aqui!
              <br>
              <a target="_blank" href="https://ajuda.lojaintegrada.com.br/pt-BR/articles/911875-como-inserir-um-codigo-html-javascript-na-minha-loja">
                Como colocar o script no seu código da Loja Integrada
              </a>
            </p>
            <p>
              <b>Pronto!</b>
              Se tudo ocorreu bem, o script do Polen já está inserido em sua página<br><br>
              Agora chegou a vez da API, você precisará adiciona-la manualmente.
              <br><br>
              Para isso, basta seguir este tutorial da própria Loja Integrada, adicionar no campo
              "Chave de API" nesta mesma página e clicar em "<b>Atualizar Acessos à API</b>"
              <br>
              <a target="_blank" href="https://ajuda.lojaintegrada.com.br/outras-configuracoes/avancadas/gerando-chave-api-e-chave-de-aplicacao">Gerando
                Chave API e Chave de Aplicação na LI
              </a>
            </p>
            <p>Ficou alguma dúvida ou está com dificuldades na integração?
              <b>Nos chame no chat</b>
            </p>
          </div>
        </div>
      </div>

      <div id="tray" *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'tray-pollinator'">
        <div class="row">
          <div>
            <div class="card">
              <div class="card-content">
                <p>Caso você tenha instalado o Polen direto via painel da Tray, está tudo certo!!!</p>
                <p>Caso você se cadastrou direto pelo site do Polen, pedimos agora que acesse seu painel de
                  aplicativos da Tray.
                  <br>
                  Temos parceria exclusiva com a Tray e ao instalar direto por lá, em um clique estamos
                  conectados com sua loja de maneira rápida e segura!
                </p>
                <p>Fizemos um vídeo explicando como adicionar o Polen dessa maneira:</p>
                <div class="videoWrapper">
                  <iframe src="https://www.youtube.com/embed/WDs1HClT9Co" allowfullscreen></iframe>
                </div>
                <br>
                <div class="alert alert-warning">
                <span>
                  Caso você <b>NÃO esteja</b> utilizando o novo template de carrinho da Tray, o Polen
                  não aparece automaticamente. Nossa TI terá que ajustar o layout posteriormente.
                </span>
                </div>
                <div class="alert alert-danger">
                <span>
                  <b>ATENÇÃO!</b> Se após instalar via Tray o script do Polen ainda não esteja
                  aparecendo, no seu painel Tray, vá até:<br><br>
                  <b style="color:black">Easy checkout > ver todas as opções > sincronizar dados</b>
                  <br><br>
                  Após feito isso, verifique novamente!
                </span>
                </div>
                <p>
                  <a style="    width: 80%;margin-left: 10%;" class="btn btn-success btn-fill btn-wd" target="_blank" href="https://clientes.tray.com.br/">Ir para painel da Tray</a>
                </p>
                <p>O Polen ainda não aparece ou ficou alguma dúvida?
                  <b>Nos chame no chat</b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="traycorp" *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'traycorp'">
        <div class="row">
          <div>
            <div class="card">
              <div class="card-content">
                <p>São apenas dois passos para adicionar o script do Polen. </p>
                <ul style="margin-left: 25px;">
                  <li>Adicionar o script no Google Tag Manager</li>
                  <li>Entrar em contato com o suporte da TrayCorp e pedir a liberação dos domínios
                    <ul>
                      <li>polen.app.br</li>
                      <li>polen.com.br</li>
                      <li>opolen.com.br</li>
                    </ul>
                  </li>
                  <li>Criar um token de acesso à API da TrayCorp para o Polen</li>
                  <li>Inserir o token criado nesta página de setup, no item 2.</li>
                </ul>
                <p>Para facilitar, acompanhe o passo a passo nos vídeos explicativos:</p>
                <br>
                <h4>Adicionando o Polen no seu Google Tag Manager</h4>
                <div class="videoWrapper">
                  <iframe src="https://www.youtube.com/embed/WuVS3-bJowA" allowfullscreen></iframe>
                </div>
                <br>
                <div class="alert alert-warning">
                <span>
                  Atenção. A TrayCorp bloqueia novos domínios que não estejam em sua lista
                  pré-aprovada da sua loja.
                  <br>
                  Para que o Polen funcione é necessário que entrar em contato com o suporte da
                  TrayCorp e pedir a liberação dos domínios
                  <ul>
                    <li>polen.app.br</li>
                    <li>polen.com.br</li>
                    <li>opolen.com.br</li>
                  </ul>
                </span>
                </div>
                <p>Por último agora você precisa criar um token de acesso à API da TrayCorp para o Polen.
                </p>
                <p>Pronto! Após conectar Sua loja está integrada e pronta pra polinizar</p>
                <br>
                <p>Ficou alguma dúvida ou está com dificuldades na integração?
                  <b>Nos chame no chat</b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="nuvemshop" *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'nuvemshop-flower'">
        <div class="row">
          <div>
            <div class="card">
              <div class="card-content">
                <p>Caso você tenha instalado o Polen direto via loja de aplicativos da NuvemShop, está tudo
                  certo!!!</p>
                <p>Caso você se cadastrou direto pelo site do Polen,
                  <a href="https://www.nuvemshop.com.br/loja-aplicativos-nuvem/1026/install" target="_blank">clique aqui para instalar o Polen</a> na sua loja NuvemShop.
                  <br>
                  <br>
                  Temos parceria exclusiva com a NuvemShop e ao instalar direto por lá, em um clique
                  estamos conectados com sua loja de maneira rápida e segura!
                </p>
                <!-- <p>Fizemos um vídeo explicando como adicionar o Polen dessa maneira:</p>
                                  <div class="videoWrapper">
                                      <iframe src="https://www.youtube.com/embed/WDs1HClT9Co" allowfullscreen></iframe>
                                  </div>
                                  <br> -->
                <div class="alert alert-warning">
                <span>
                  Atenção. O Polen pode não aparecer automaticamente no seu carrinho caso ele seja
                  personalizado.
                  <br>
                  Nesse caso, nossa TI em até 48 horas fará o ajuste dentro do seu layout para
                  exibirmos.
                </span>
                </div>
                <p>
                  <a style="    width: 80%;margin-left: 10%;" class="btn btn-success btn-fill btn-wd" target="_blank" href="https://www.nuvemshop.com.br/loja-aplicativos-nuvem/1026/install">Instalar
                    Polen na NuvemShop</a>
                </p>
                <p>O Polen ainda não aparece ou ficou alguma dúvida?
                  <b>Nos chame no chat</b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="xtech" *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'xtech-flower'">
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="card-content">
                <p>Caso você tenha instalado o Polen direto via painel da xtech, está tudo certo!!!</p>
                <p>Caso você se cadastrou direto pelo site do Polen, pedimos agora que acesse seu painel de
                  aplicativos da xtech.
                  <br>
                  Temos parceria exclusiva com a xtech e ao instalar direto por lá, em um clique estamos
                  conectados com sua loja de maneira rápida e segura!
                </p>
                <p>Fizemos um vídeo explicando como adicionar o Polen dessa maneira:</p>
                <div class="videoWrapper">
                  <iframe src="https://www.youtube.com/embed/QzSeTkr_gE4" allowfullscreen></iframe>
                </div>
                <br>
                <p>
                  <a style="width: 80%;margin-left: 10%;" class="btn btn-success btn-fill btn-wd" target="_blank" href="https://www.xtechcommerce.com/">Ir para painel da xtech</a>
                </p>
                <p>Ficou alguma dúvida ou está com dificuldades na integração?
                  <b>Nos chame no chat</b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="irroba" *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'irroba'">
        <div class="row">
          <div>
            <div class="card">
              <div class="card-content">
                <p>São apenas dois passos para adicionar o script do Polen. </p>
                <ul style="margin-left: 25px;">
                  <li>Adicionar o script no Google Tag Manager</li>
                  <li>Adicionar a chave de acesso para sua API</li>
                </ul>
                <p>Para facilitar, fizemos um vídeo rápido explicativo:</p>
                <br>
                <h4>Adicionando o Polen no seu Google Tag Manager</h4>
                <p> Se você ainda não possui o script do Polen em todas as páginas do seu e-commerce basta assistir o video de integração
                  utilizando o Google Tag Manager. Porém se você já possui os scripts nas suas páginas basta pular para o passo seguinte.
                </p>
                <div class="videoWrapper">
                  <iframe src="https://www.youtube.com/embed/WuVS3-bJowA" allowfullscreen></iframe>
                </div>
                <h4>Como pedir sua chave de acesso para sua API?</h4>
                <div>
                  <p> Para integrar o API com o Polen necessitamos de duas informações: um usuário e a senha. Conseguir o seu usuário e senha (que é exclusivo para o Polen) é bem simples é bem simples, basta
                    acessar o link <a href="https://www.irroba.com.br/dev/" target="_blank">API IRROBA</a> e solicitar
                    seu acesso pelo e-mail que aparece na página.
                  </p>
                </div>
                <br>
                <p>Pronto! Sua loja está integrada e pronta pra polinizar</p>
                <br>
                <p>Ficou alguma dúvida ou está com dificuldades na integração?
                  <b>Nos chame no chat</b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="cartx" *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'cartx'">
        <div class="row">
          <div>
            <div class="card">
              <div class="card-content">
                <p>Caso você tenha instalado o Polen direto via loja de aplicativos da CartX, está tudo
                  certo!!!</p>
                <p>Caso você se cadastrou direto pelo site do Polen
                  <br>
                  Temos parceria exclusiva com a CartX e ao instalar direto por lá, em um clique
                  estamos conectados com sua loja de maneira rápida e segura!
                </p>
                <p>Fizemos um vídeo explicando como adicionar o Polen dessa maneira:</p>
                <div class="videoWrapper">
                  <iframe width="772" height="433" src="https://www.youtube.com/embed/A-jttR_iI5c" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <br>
                <div class="alert alert-warning">
                <span>
                  Atenção. O Polen pode não aparecer automaticamente no seu carrinho caso ele seja
                  personalizado.
                  <br>
                  Nesse caso, nossa TI em até 48 horas fará o ajuste dentro do seu layout para
                  exibirmos.
                </span>
                </div>
                <p>
                  <a style="    width: 80%;margin-left: 10%;" class="btn btn-success btn-fill btn-wd" target="_blank" href="https://accounts.cartx.io/apps/polen/create">Instalar
                    Polen na CartX</a>
                </p>
                <p>O Polen ainda não aparece ou ficou alguma dúvida?
                  <b>Nos chame no chat</b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="shopify" 
          *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'shopify'">
        <div class="row">
          <div>
            <div class="card">
              <div class="card-content">
                <p>
                  Caso você tenha instalado o Polen direto via loja de aplicativos da Shopify, temos uma
                  pergunta para você:
                </p>
                <div class="alert alert-warning" role="alert">
                  <p style="color: #856404;">
                    <strong>Qual é o checkout que você utiliza?</strong>
                    <br><br>
                    Essa pergunta é importante para podermos serguir para os próximos passos de configuração da
                    ferramenta no seu e-commerce. Caso você utilize como checkout CartX ou Yampi, temos alguns videos
                    para a continuiudade a sua instalação e entre em contato com o nosso CS para um melhor
                    aconselhamento.
                  </p>
                </div>
                
                <p>Fizemos um vídeo explicando como adicionar o Polen a partir dos aplicativos da CartX:</p>
                <div class="videoWrapper">
                  <iframe width="500" height="300" src="https://www.youtube.com/embed/A-jttR_iI5c" title="Video instalação CartX" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>
                <p>
                  <a style="width: 80%;margin-left: 10%;margin-top:2%;" class="btn btn-success btn-fill btn-wd" target="_blank"
                    href="https://accounts.cartx.io/apps/polen/create">Instalar
                    Polen na CartX</a>
                </p>
                <br>
                <p>Fizemos um vídeo explicando como adicionar o Polen caso você use Yampi como seu checkout:</p>
                <div class="videoWrapper">
                  <iframe width="772" height="433" src="https://www.youtube.com/embed/TmjsvHVfUl8" title="Video instalação Yampi" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>
                <br>
                
                <p>
                  <a style="width: 80%;margin-left: 10%;margin-top:2%;" class="btn btn-success btn-fill btn-wd" target="_blank"
                    href="https://app.yampi.com.br/">
                    Instalar Polen na Yampi</a>
                </p>
                <p>Caso use o checkout nativo da Shopify estamos pronto para começar 
                </p>

                <div class="alert alert-warning">
                  <span>
                    Atenção. O Polen pode não aparecer automaticamente no seu carrinho caso ele seja
                    personalizado.
                    <br>
                    Nesse caso, nossa TI em até 48 horas fará o ajuste dentro do seu layout para
                    exibirmos.
                  </span>
                </div>
                <p>O Polen ainda não aparece ou ficou alguma dúvida?
                  <b>Nos chame no chat</b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="yampi" *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'yampi'">
        <div class="row">
          <div>
            <div class="card">
              <div class="card-content">
                <p>
                  Caso você se cadastrou direto pelo site do Polen, estamos a um passo para concluir a instalação.
                  Precisamos instalar nosso script nas suas páginas Yampi.
                </p>
                <p>Fizemos um vídeo explicando como adicionar o script Polen dessa maneira:</p>
                <div class="videoWrapper">
                  <iframe width="772" height="433" src="https://www.youtube.com/embed/TmjsvHVfUl8" title="Tutorial Loom Yampi" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <br>
                <div class="alert alert-warning">
                  <span>
                    Atenção. O Polen pode não aparecer automaticamente no seu carrinho caso ele seja
                    personalizado.
                    <br>
                    Nesse caso, nossa TI em até 48 horas fará o ajuste dentro do seu layout para
                    exibirmos.
                  </span>
                </div>
                <div class="alert alert-danger">
                  <span>
                    <p>Caso você tenha a sua loja Shoppify e o checkout como Yampi:
                      <br>
                      Precisamos que você desinstale o nosso aplicativo na Shopify e siga o passo anterior.
                      E peça para nosso CS acompanhar a migração.
                    </p>               
                    
                  </span>
                </div> 
                <p>Agora que terminamos a instalação, precisamos conectar a API:</p>
                <p>Porque é importante conectar a API?
                  <br>
                  É com ela que controlamos quais compras foram pagas e assim gerar a doação (caso exista) e 
                  desconsideramos as doações vindas de compras não pagas.
                </p>
                <p>
                  A autenticação na API da Yampi é bem simples. Você deverá passar duas informações:
                  <br>
                   - User-Token
                   <br>
                   - User-Secret-Key
                   <br>
                  Ambas as informações estão disponíveis no painel da Yampi, em Credenciais de API:
                </p>
                <img src="../../assets/img/credenciais-yampi.png" />
                <p>O Polen ainda não aparece ou ficou alguma dúvida?
                  <b>Nos chame no chat</b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="vnda" *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'vnda'">
        <div class="row">
          <div>
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">
                    <b>Adicionando o Polen no seu Google Tag Manager (GTM)</b>
                  </h4>
                </div>
                <div class="card-content">
                  <iframe width="550px" height="350px" src="https://www.useloom.com/embed/24613bf0a8054b88ae3009d7ec4b823a" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                  <p>Pronto! Sua loja está integrada e pronta pra polinizar</p>
                  <p>Ficou alguma dúvida ou está com dificuldades na integração?
                    <b>Nos chame no chat</b>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="card">
                <div class="card-content">
                  <ul>
                    <li>
                      <h3>Gerando a chave de API</h3>
                    </li>
                    <li>Vá em Admin > Configurações ⚙️ > Integrações > API;</li>
                    <li>
                      <p>Clique no ícone de "+" para gerar um novo token:</p>
                      <img src="https://downloads.intercomcdn.com/i/o/592796384/845539f57ec8c282e62311fd/image.png" alt="Primeiro passo do API para a VNDA">
                    </li>
                    <li><p>Preencha com o nome e o  e-mail de quem deve receber o token;</p></li>
                    <li>
                      <p>Deixe o campo hosts em branco e preencha o escopo ao qual essa chave de API terá acesso;</p>
                      <img src="https://downloads.intercomcdn.com/i/o/592801171/18d8433d98df38b4983a2176/api_vnda.gif" alt="Segundo passo do API para a VNDA" srcset="">
                    </li>
                    <li>
                      <p>Feito isso, clique em salvar. O token será gerado e enviado ao e-mail selecionado. O assunto do e-mail sempre será Token de acesso para API da Vnda.</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>          
          </div>
        </div>
      </div>

      <div class="container-fluid"
           *ngIf="profile.platformInfo.seoName != 'cartx' && profile.platformInfo.seoName != 'woocommerce-flower'  
           && profile.platformInfo.seoName != 'irroba' && profile.platformInfo.seoName != 'xtech-flower'  
           && profile.platformInfo.seoName != 'loja-integrada-flower' && profile.platformInfo.seoName != 'vtex-flower' 
           && profile.platformInfo.seoName != 'traycorp' && profile.platformInfo.seoName != 'tray-pollinator'  
           && profile.platformInfo.seoName != 'nuvemshop-flower' && profile.platformInfo.seoName != 'yampi'
           && profile.platformInfo.seoName != 'shopify' && profile.platformInfo.seoName != 'vnda'">
        <div class="row" *ngIf="profile.platformInfo != null && profile.platformInfo.fullInstallation">
        </div>
        <div class="row" *ngIf="profile.platformInfo && profile.platformInfo.id == '59c41365-e65f-418f-80a3-ef579fa99cfd'.toLowerCase()">
          <div class="col-md-12">
            <div class="card">
              <div class="card-content">
                <p>Veja como é simples adicionar o Polen no seu e-commerce VTex.</p>
                <p>São apenas dois passos para adicionar o script do Polen. </p>
                <ul style="margin-left: 25px;">
                  <li>Adicionar o script no Google Tag Manager, que você encontra no final desta página
                  </li>
                  <li>Associar sua conta Google Tag Manager no admin da VTex</li>
                </ul>
                <br>
                <br>
                <h4>Adicionando o Polen no seu Google Tag Manager (GTM)</h4>
                <iframe width="550px" height="350px" src="https://www.useloom.com/embed/24613bf0a8054b88ae3009d7ec4b823a" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                <h4>Associando o GTM no admin da VTex</h4>
                <iframe width="550px" height="350px" src="https://www.useloom.com/embed/9b6f4a056c41448087e8a5191e23264d" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                <p>Pronto! Sua loja está integrada e pronta pra polinizar</p>
                <br>
                <p>Ficou alguma dúvida ou está com dificuldades na integração?
                  <b>Nos chame no chat</b>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="profile.platformInfo && profile.platformInfo.id == 'fe134638-ef62-41ec-8bc3-4ec2e30b463b'.toLowerCase()">
          <div class="col-md-12">
            <div class="card">
              <div class="card-content">
                <div class="row">
                  <div class="col-md-12">
                    <p>Veja como é simples adicionar o Polen no seu e-commerce Loja integrada.</p>
                    <p>São apenas dois passos para adicionar o script do Polen. </p>
                    <ul style="margin-left: 25px;">
                      <li>Adicionar o script no Google Tag Manager, que você encontra no final desta
                        página</li>
                      <li>Associar sua conta Google Tag Manager no admin da Loja Integrada</li>
                    </ul>
                    <br>
                    <br>
                    <h4>Adicionando o Polen no seu Google Tag Manager (GTM)</h4>
                    <iframe width="550px" height="350px" src="https://www.useloom.com/embed/24613bf0a8054b88ae3009d7ec4b823a" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                    <h4>Associando o GTM no admin da Loja Integrada</h4>
                    <iframe width="550px" height="350px" src="https://www.useloom.com/embed/08a184baded849719c1f6434fa1643a9" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                    <p>Pronto! Sua loja está integrada e pronta pra polinizar</p>
                    <br>
                    <p>Ficou alguma dúvida ou está com dificuldades na integração?
                      <b>Nos chame no chat</b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="profile.platformInfo != null && profile.platformInfo.fullInstallation">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">
                  <b>Adicionando o Polen no seu Google Tag Manager (GTM)</b>
                </h4>
              </div>
              <div class="card-content">
                <iframe width="550px" height="350px" src="https://www.useloom.com/embed/24613bf0a8054b88ae3009d7ec4b823a" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                <p>Pronto! Sua loja está integrada e pronta pra polinizar</p>
                <p>Ficou alguma dúvida ou está com dificuldades na integração?
                  <b>Nos chame no chat</b>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="profile.platformInfo == null || (profile.platformInfo && !profile.platformInfo.fullInstallation)">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">
                  <b>Ops, Ainda não temos uma integração pronta para a {{profile.platformInfo.name}}</b>
                </h4>
              </div>
              <div class="card-content">
                <div class="lead">
                  <p>Mas você pode nos ajudar a adiantar essa integração</p>
                  <p>Traga os amigos para polinizar!!!</p>
                  <p>Você pode nos ajudar a priorizarmos a {{profile.platformInfo.name}} convidando mais
                    lojistas
                    dessa plataforma</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="profile.platformInfo == null">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              <b>Ops, sua loja não está em uma plataforma já integrada ao Polen.</b>
            </h4>
          </div>
          <div class="card-content">
            <div class="lead">
              <p>1. Caso sua loja seja de uma plataforma ou agência, nos ajude a priorizar ela indicando o
                Polen para sua plataforma.</p>
              <p>2. Caso sua loja tenha tecnologia própria, vamos conversar para criarmos uma <b>estratégia e
                integração</b> personalizada para sua marca.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="right-side-setup">

    <h4>Status</h4>

    <div class="card">
      <div class="card-content">
        <form name="form" (ngSubmit)="formConfig.form.valid && saveConfig()" #formConfig="ngForm"
              novalidate>
          <div class="content">
            <div class="row">
              <div class="col-md-12 select-setup-api">
                <label
                  tooltip="Defina se a caixa de doação do Polen está aparecendo ou não no seu site.">Polen
                  ativo no seu site</label>
                <i tooltip="Defina se a caixa de doação do Polen está aparecendo ou não no seu site."
                   class="fa fa-question-circle" style="float: right;"></i>

                <div>
                  <div style="float: left; margin-right: 20px; margin-top: 6px;">
                    <img *ngIf="profile.integrationActive" style="width:25px"
                         title="Visualização Ativada!"
                         src="https://storage.googleapis.com/sealpolen-files.polinizador.com.br/images/icones/checked.png" />
                    <img *ngIf="!profile.integrationActive" style="width:25px"
                         title="Visualização desativada!"
                         src="https://cdn.iconscout.com/icon/premium/png-256-thumb/cancel-251-754627.png" />
                  </div>
                  <select class="form-control" name="integrationActive" style="width: 83%;"
                          [(ngModel)]="profile.integrationActive">
                    <option [value]="true">Visibilidade Ativa</option>
                    <option [value]="false">Visibilidade Desativada</option>
                  </select>
                  <div class="text-right btn-setup">
                    <button type="submit" class="btn btn-info btn-fill">Atualizar</button>
                  </div>
                </div>
              </div>
              <div class="col-md-12 input-setup-api">
                <label
                  tooltip="Verificamos se o pixel/script/linha de código do Polen está ativa ou não na sua loja.">Status da sua loja</label>
                <i tooltip="Verificamos se o pixel/script/linha de código do Polen está ativa ou não na sua loja."
                   class="fa fa-question-circle" style="float: right;"></i>
                <br>
                <div style="float: left; margin-right: 20px; margin-top: 6px;">
                  <img *ngIf="profile.scriptValidated" style="width:25px"
                       title="Script instalado!"
                       src="https://storage.googleapis.com/sealpolen-files.polinizador.com.br/images/icones/checked.png" />
                  <img *ngIf="!profile.scriptValidated" style="width:25px"
                       title="Script não encontrado em seu site!"
                       src="https://cdn.iconscout.com/icon/premium/png-256-thumb/cancel-251-754627.png" />
                </div>
                <div>
                  <button *ngIf="profile.scriptValidated" type="button"
                          class="btn btn-success">Script
                    identificado na sua loja</button>
                  <button *ngIf="!profile.scriptValidated" (click)="lookforScript()"
                          type="button" class="btn btn-info btn-fill">Verificar
                    Script no Site</button>
                </div>
              </div>
              <div class="col-md-12 input-setup-api">
                <div style="float: left; margin-right: 20px;">
                  <img *ngIf="profile.isValidApi" style="width:25px"
                       title="A API está conectada, logo est"
                       src="https://storage.googleapis.com/sealpolen-files.polinizador.com.br/images/icones/checked.png" />
                  <img *ngIf="!profile.isValidApi" style="width:25px"
                       title="A API não está conectada e não conseguimos verificar se as compras foram pagas ou não."
                       src="https://cdn.iconscout.com/icon/premium/png-256-thumb/cancel-251-754627.png" />
                </div>
                <div>
                  <div class="btn btn-success" *ngIf="profile.isValidApi" style="font-size: 16px;float:left">API
                    conectada</div>
                  <div *ngIf="!profile.isValidApi" style="font-size: 16px;float:left">API não
                    conectada</div>
                  <button class="btn btn-info btn-fill btn-sm" (click)="updateApiStatus()"
                          type="click" style="float: right;"
                          tooltip="Atualizar status de conexão do Polen com a API da sua loja.">
                    <i class="ti-reload"></i></button>
                </div>
              </div>
              <div class="col-md-12 input-setup-api">
                <div style="float: left; margin-right: 20px;">
                  <img *ngIf="profile.activePayingUser" style="width:25px"
                       title="Cliente pagante!"
                       src="https://storage.googleapis.com/sealpolen-files.polinizador.com.br/images/icones/checked.png" />
                  <img *ngIf="!profile.activePayingUser" style="width:25px"
                       title="Cliente não é pagante ainda!"
                       src="https://cdn.iconscout.com/icon/premium/png-256-thumb/cancel-251-754627.png" />
                </div>
                <div>
                  <div class="btn btn-success" *ngIf="profile.activePayingUser" style="font-size: 16px;">Assinatura
                    ativa</div>
                  <div *ngIf="!profile.activePayingUser" style="font-size: 16px;">Sem
                    assinatura</div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <h4 *ngIf="profile.platformInfo.seoName === 'cartx' || profile.platformInfo.seoName === 'woocommerce-flower' || profile.platformInfo.seoName === 'irroba' || profile.platformInfo.seoName === 'xtech-flower' || profile.platformInfo.seoName === 'loja-integrada-flower' || profile.platformInfo.seoName === 'vtex-flower' || profile.platformInfo.seoName === 'traycorp'">Chaves da API</h4>
    <div class="card api-access">
      <div *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'vtex-flower'">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12" *ngIf="apiAccess != null">
              <form #fInfo="ngForm" class="form-horizontal" novalidate (ngSubmit)="saveApiAccess()">
                <div class="card-content">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <label class="control-label">AppKey:</label>
                      <input class="form-control" type="text" name="key" [(ngModel)]="apiAccess.key" required #key="ngModel">
                    </div>
                    <div class="col-sm-12">
                      <label class="control-label">AppToken:</label>
                      <input class="form-control" type="text" name="token" [(ngModel)]="apiAccess.token" required #token="ngModel">
                    </div>
                    <div class="col-sm-12">
                      <label class="control-label">AccountName na Vtex:</label>
                      <input class="form-control" type="text" name="platformStoreName" [(ngModel)]="apiAccess.platformStoreName" required #platformStoreName="ngModel">
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <button type="submit" class="btn btn-info btn-fill">Atualizar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'woocommerce-flower'">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12" *ngIf="apiAccess != null">
              <form #fInfo="ngForm" class="form-horizontal" novalidate (ngSubmit)="saveApiAccess()">
                <div class="card-content">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <label class="control-label">consumer_key:</label>
                      <input class="form-control" type="text" name="key" [(ngModel)]="apiAccess.key" required #key="ngModel">
                    </div>
                    <div class="col-sm-12">
                      <label class="control-label">consumer_token:</label>
                      <input class="form-control" type="text" name="token" [(ngModel)]="apiAccess.token" required #token="ngModel">
                    </div>
                    <div class="col-sm-12">
                      <label class="control-label">Domínio da API (sem https://):</label>
                      <input class="form-control" type="text" name="platformStoreName" [(ngModel)]="apiAccess.platformStoreName" required #platformStoreName="ngModel" placeholder="dominio.com.br">
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <button type="submit" class="btn btn-info btn-fill">Atualizar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'loja-integrada-flower'">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12" *ngIf="apiAccess">
              <form #fInfo="ngForm" class="form-horizontal" novalidate (ngSubmit)="saveApiAccess()">
                <div class="card-content">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <label class="control-label">AppKey:</label>
                      <input class="form-control" type="text" name="key" [(ngModel)]="apiAccess.key" required #key="ngModel">
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <button type="button" (click)="saveApiAccess()" class="btn btn-info btn-fill">Atualizar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'traycorp'">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12" *ngIf="apiAccess != null">
              <form #fInfo="ngForm" class="form-horizontal" novalidate (ngSubmit)="saveApiAccess()">
                <div class="card-content">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <label class="control-label">Token:</label>
                      <input class="form-control" type="text" name="token" [(ngModel)]="apiAccess.token" required #token="ngModel">
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <button type="submit" class="btn btn-info btn-fill">Atualizar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div  *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'xtech-flower'">
        <div class="card-content" *ngIf="apiAccess">
          <div class="row">
            <div class="col-md-12">
              <form #fInfo="ngForm" class="form-horizontal" novalidate (ngSubmit)="saveApiAccess()">
                <div class="card-content">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <label class="control-label">Api Key:</label>
                      <input class="form-control" type="text" name="key" [(ngModel)]="apiAccess.key" required #key="ngModel">
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <button type="button" (click)="saveApiAccess()" class="btn btn-info btn-fill">Atualizar</button>
                </div>
              </form>
              <br>
              <p><a target="_blank" href="https://ajuda.xtechcommerce.com/pt-BR/articles/3355737-como-gerar-o-meu-api-token">Como
                gerar o meu API token na xtech?</a></p>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'irroba'">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12" *ngIf="apiAccess != null">
              <form #fInfo="ngForm" class="form-horizontal" novalidate (ngSubmit)="saveApiAccess()">
                <div class="card-content">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <label class="control-label">Usuário:</label>
                      <input class="form-control" type="text" name="key" [(ngModel)]="apiAccess.key" required #key="ngModel">
                    </div>
                    <div class="col-sm-12">
                      <label class="control-label">Senha:</label>
                      <input class="form-control" type="text" name="token" [(ngModel)]="apiAccess.token" required #token="ngModel">
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <button type="submit" class="btn btn-info btn-fill">Atualizar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'cartx'">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12" *ngIf="apiAccess != null">
              <form #fInfo="ngForm" class="form-horizontal" novalidate (ngSubmit)="saveApiAccess()">
                <div class="card-content">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <label class="control-label">API-Key:</label>
                      <input class="form-control" type="text" name="token" [(ngModel)]="apiAccess.token" required #token="ngModel">
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <button type="submit" class="btn btn-info btn-fill">Atualizar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>      
      <div *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'yampi'">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12" *ngIf="apiAccess != null">
              <form #fInfo="ngForm" class="form-horizontal" novalidate (ngSubmit)="saveApiAccess()">
                <div class="card-content">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <label class="control-label">User-Secret-Key:</label>
                      <input class="form-control" type="text" name="key" [(ngModel)]="apiAccess.key" required #key="ngModel">
                    </div>
                    <div class="col-sm-12">
                      <label class="control-label">User-Token:</label>
                      <input class="form-control" type="text" name="token" [(ngModel)]="apiAccess.token" required #token="ngModel">
                    </div>
                    <div class="col-sm-12">
                      <label class="control-label">Alias:</label>
                      <input class="form-control" type="text" name="platformStoreName" [(ngModel)]="apiAccess.platformStoreName" required #platformStoreName="ngModel" placeholder="dominio">
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <button type="submit" class="btn btn-info btn-fill">Atualizar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="profile.platformInfo != null && profile.platformInfo.seoName == 'vnda'">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12" *ngIf="apiAccess != null">
              <form #fInfo="ngForm" class="form-horizontal" novalidate (ngSubmit)="saveApiAccess()">
                <div class="card-content">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <label class="control-label">API:</label>
                      <input class="form-control" type="text" name="key" [(ngModel)]="apiAccess.key" required #key="ngModel">
                    </div>
                    <div class="col-sm-12">
                      <label class="control-label">Dominio:</label>
                      <input class="form-control" type="text" name="platformStoreName" [(ngModel)]="apiAccess.storeUrl" required #platformStoreName="ngModel" placeholder="dominio">
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <button type="submit" class="btn btn-info btn-fill">Atualizar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
